import { BirthCertificateDoc } from '../../../../types';

type BirthCertDocMeta = Pick<BirthCertificateDoc, 'isLegalDocument' | 'isInEnglish' | 'hasProvidedTranslation'>;

const getHighlightedErrorSections = (doc: BirthCertDocMeta) => {
  const { isLegalDocument, isInEnglish, hasProvidedTranslation } = doc;

  // Are there any errors?
  // highlight the specific sections
  const isLegalDocumentHighlight = isLegalDocument === false ? ['1.1'] : [];
  const isInEnglishErrorHighlight =
    isInEnglish === false && hasProvidedTranslation === false ? ['2.1', '2.2', '2.3', '2.4', '2.5'] : [];

  if (isLegalDocumentHighlight.length || isInEnglishErrorHighlight.length) {
    // unique values only AND
    // remove empty strings in array
    return [...new Set([...isLegalDocumentHighlight, ...isInEnglishErrorHighlight].filter(Boolean))];
  }
  return [];
};
export default getHighlightedErrorSections;
